import React from "react";
import { withTranslation } from "react-i18next";
import TagSelection from "../tagSelection/TagSelection";

const TemplateSearch = props => {
  const { t } = props;
  return (
      <TagSelection
        {...props}
        onChange={selectedTags => props.onChange(selectedTags)}
        max={10}
        selectedTags={props.selectedTags}
        placeholder={t("InstanceTemplates.Modal.Form.TagsPlaceholder")}
        className="mb-3"
      />
  );
};

export default withTranslation()(TemplateSearch);
